import axios from 'axios';

class ACHTTPClient {
    constructor() {
        // Set config defaults when creating the instance
        this.client = axios.create();
    }
    withAuthorizationHeader(authhorizationHeader) {
        // Alter defaults after instance has been created
        this.client.defaults.headers.common['Authorization'] = authhorizationHeader;
    }
    async request(input) {
        try {
            return await this.client({ ...input });
        } catch (error) {
            let result = error;
            console.error('Error ACHTTPClient:request', error, error.response ?? `response: ${error.response}`);

            if (error instanceof ACError === false) {
                let status;
                if (error.response && error.response.status) {
                    status = error.response.status;
                }
                result = new ACError(error.message, status);
            }
            return Promise.reject(result);
        }
    }
}

class ACError extends Error {
    constructor(message, code, type, isIgnorable) {
        super(message);
        this.name = 'ACError';
        this.code = code;
        this.httpStatusCode = code;
        this.type = type;
        this.isIgnoreable = isIgnorable || false;
    }
}

export default new ACHTTPClient();
